<template>
  <div>
    <MainPage class="font-Host" />
  </div>
</template>

<script>
import MainPage from "./views/MainPage.vue";

export default {
  name: "App",
  components: {
    MainPage,
  },
};
</script>
